// One css2 <link> per (family, weight, text): the preview face of a Google row. `text` is always a fixed sample — the
// family name, plus the F7 CJK sample — never the visitor's text. The browser fetches only those glyphs (a .woff2 of the
// interface kind, never a model font: R14 and spec rev 2's "no model font file" — e2e/lib/fonts.js isModel).
const seen = new Set();
export function loadGooglePreview(family, weight, text) {
  const href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, '+')}:wght@${encodeURIComponent(weight)}&text=${encodeURIComponent(text)}&display=swap`;
  if (seen.has(href)) return;
  seen.add(href);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}
